<template>
	<svg t="1686291840812" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2460"
		xmlns:xlink="http://www.w3.org/1999/xlink" width="200" height="200">
		<path d="M566.95 110.48v785.91h376.07V110.48H566.95z m-500.13 2.83v786.37h369.19V113.31H66.82z" p-id="2461"></path>
	</svg>
</template>
